import { createReducer, on } from '@ngrx/store';
import { authActions } from '../actions/auth.actions';

export interface AuthState {
    loggedIn: boolean | null;
    error: number | null;
}

export const initialState: AuthState = {
    loggedIn: null,
    error: null,
};

export const authReducer = createReducer(
    initialState,
    on(authActions.loginWithPin, (state): AuthState => ({
        ...state,
        loggedIn: null,
        error: null,
    })),
    on(authActions.loginWithPinSuccess, (state): AuthState => ({
        ...state,
        loggedIn: true,
        error: null,
    })),
    on(authActions.loginWithPinError, (state, { code }): AuthState => ({
        ...state,
        loggedIn: false,
        error: code,
    })),
    on(authActions.clear, (): AuthState => ({ ...initialState })),
);
